module.exports = __webpack_public_path__ + "static/img/cosme.cb8e4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/cosme.jpg
// module id = R2vQ
// module chunks = 23